import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';

const ManifestoModal = ({ onClose }) => (
  <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-in fade-in duration-200">
    <div className="relative w-full max-w-3xl bg-yellow-400 border-4 border-black shadow-[16px_16px_0px_white] p-8 md:p-12 overflow-hidden flex flex-col max-h-[90vh] overflow-y-auto">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 bg-black text-white p-2 hover:bg-white hover:text-black border-2 border-transparent hover:border-black transition-all"
        aria-label="Close"
      >
        <X size={28} />
      </button>
      <h2 className="text-5xl md:text-7xl font-black mb-8 uppercase tracking-tighter border-b-4 border-black pb-4">
        THE MANIFESTO
      </h2>
      <div className="space-y-8 font-bold text-lg md:text-xl font-mono">
        <div className="bg-white p-6 border-4 border-black shadow-[8px_8px_0px_black] transform rotate-1">
          <h3 className="text-2xl font-black bg-black text-white inline-block px-3 py-1 mb-2 uppercase">01 // The Source</h3>
          <p>
            We are committed to bringing new designs straight from the source.
            <span className="bg-black text-yellow-400 px-1 ml-1">Gen Z fans</span> and independent designers fuel our aesthetic.
            No corporate suits. Just raw creativity.
          </p>
        </div>
        <div className="bg-white p-6 border-4 border-black shadow-[8px_8px_0px_black] transform -rotate-1">
          <h3 className="text-2xl font-black bg-black text-white inline-block px-3 py-1 mb-2 uppercase">02 // The Hands</h3>
          <p>
            Every piece is crafted by <span className="bg-black text-yellow-400 px-1">Artisans from NGOs</span>.
            We do everything to ensure fair wages and dignity. Fashion should empower, not exploit.
          </p>
        </div>
        <div className="bg-white p-6 border-4 border-black shadow-[8px_8px_0px_black] transform rotate-1">
          <h3 className="text-2xl font-black bg-black text-white inline-block px-3 py-1 mb-2 uppercase">03 // The Material</h3>
          <p>
            We source our material from <span className="bg-black text-yellow-400 px-1">good sources</span>.
            Ethical, sustainable, and built to last. Respect the planet while you conquer the streets.
          </p>
        </div>
      </div>
      <div className="mt-12 text-center">
        <div className="text-xs font-black tracking-[0.3em] uppercase opacity-60">
          EST. 2024 /// DESIGNED IN THE VOID /// WORLDWIDE
        </div>
      </div>
    </div>
  </div>
);

const SiteFooter = () => {
  const [manifestoOpen, setManifestoOpen] = useState(false);

  return (
    <>
      <footer className="bg-black text-white p-12 md:p-20 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]"></div>
        <div className="relative z-10 flex flex-col items-center">
          <Sparkles className="mb-2 animate-spin-slow" size={32} />
          <img
            src="/owlfit-logo.png"
            alt="OWLFIT — Own Your Perspective"
            className="w-full max-w-2xl md:max-w-3xl mb-8 object-contain drop-shadow-[0_0_40px_rgba(168,85,247,0.5)]"
            draggable="false"
          />
          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8 text-xs md:text-sm">
            <a
              href="https://www.instagram.com/owlfit_hood/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase"
            >
              INSTAGRAM
            </a>
            <button
              onClick={() => setManifestoOpen(true)}
              className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase"
            >
              MANIFESTO
            </button>
            <Link to="/blog" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              JOURNAL
            </Link>
            <Link to="/lookbook" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              LOOKBOOK
            </Link>
            <Link to="/drops" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              DROPS
            </Link>
            <Link to="/order/track" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              TRACK
            </Link>
            <Link to="/size-guide" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              SIZE GUIDE
            </Link>
            <Link to="/returns" className="font-bold border-2 border-white px-4 py-2 hover:bg-white hover:text-black transition-colors uppercase">
              RETURNS
            </Link>
          </div>
          <p className="opacity-50 font-mono text-xs tracking-widest">
            © {new Date().getFullYear()} OWLFIT STREETWEAR. DESIGNED IN THE VOID.
          </p>
        </div>
      </footer>
      {manifestoOpen && <ManifestoModal onClose={() => setManifestoOpen(false)} />}
    </>
  );
};

export default SiteFooter;
